/**
 * 高德地图动态生成script标签，异步加载
 * @author ZhangXW
 */
export default {
  init: function () {
    const KEY = '96fdc3717d15e6d9f5b1624c67123d62'
    const AMapURL = 'https://webapi.amap.com/maps?v=1.4.14&key=' + KEY + '&plugin=AMap.Geocoder&callback=onApiLoaded'
    return new Promise((resolve, reject) => {
      // 如果已加载直接返回
      if (typeof window.AMap !== 'undefined') {
        resolve(window.AMap)
        return true
      }
      // 高德地图异步加载回调处理
      window.onApiLoaded = function () {
        console.log('高德地图脚本初始化成功...')
        resolve(window.AMap)
      }
      // 插入script脚本
      let jsapi = document.createElement('script')
      jsapi.charset = 'utf-8'
      jsapi.src = AMapURL
      document.head.appendChild(jsapi)
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/AMap.js